import api from "../store/services/api";

export const getDeliveryServices = async (params) =>
  await api.get("/delivery-services/", { params });

export const getDeliveryServiceById = async (id) =>
  await api.get(`/delivery-services/${id}/`);

export const createDeliveryService = async (deliveryService) =>
  await api.post("/delivery-services/", deliveryService, {
    headers: { "Content-Type": "application/json" },
  });

export const editDeliveryService = async (deliveryService, id) =>
  await api.put(`/delivery-services/${id}/`, deliveryService, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteDeliveryService = async (id) =>
  await api.delete(`/delivery-services/${id}/`);

const DeliveryServiceService = {
  getDeliveryServices,
  getDeliveryServiceById,
  createDeliveryService,
  editDeliveryService,
  deleteDeliveryService,
};

export default DeliveryServiceService;
